import {Alert, Box} from '@mui/material';
import {TFunction} from 'i18next';

export default function MutationStatusIndicator({
  mutationStatus,
  error,
  t
}: {
  mutationStatus: 'error' | 'idle' | 'loading' | 'success';
  error: string;
  t: TFunction;
}) {
  if (mutationStatus !== 'error') {
    return null;
  }

  const errorMessages: Record<string, string> = {
    isDermatologyDomain: 'ui:diagnosticReport.imageError.cardSubheaderHeader.isDermatological',
    qualityAcceptable: 'ui:diagnosticReport.imageError.cardSubheaderHeader.qualityAcceptable',
    invalidPose: 'ui:diagnosticReport.imageError.cardSubheaderHeader.invalidPose'
  };

  const errorMessageKey = errorMessages[error] || 'ui:diagnosticReport.imageError.generalError';

  return (
    <Box
      sx={{
        display: 'flex',
        mt: 1
      }}
    >
      <Alert sx={{width: '100%'}} severity="error">
        {t(errorMessageKey)}
      </Alert>
    </Box>
  );
}
